import React, { useState } from 'react';
import styled from 'styled-components';
import ContactUsModal from '../../shared/components/modals/ContactUsModal';

// Adjusted styled components
const FooterContainer = styled.footer`
  background-color: rgb(35, 47, 62);
  padding: 40px 0; // Increased padding for more vertical space
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
`;

const DecorativeLine = styled.div`
  height: 1px;
  background-color: #e0e0e0; // Light grey for subtlety
  width: 80%; // Controls the width of the line
  margin: 0 auto 20px; // Centers the line and adds space below it
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  max-width: 1400px; // Increased max-width for more horizontal spread
  margin: 0 auto;
  padding: 0 15px;
  gap: 60px; // Increased gap between columns

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

const FooterNav = styled.div`
  margin: 20px 0;

  h4 {
    margin-bottom: 15px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 15px; // Added bottom margin for space above additional text
  }

  ul li a, p a {
    text-decoration: none;
    color: #007bff;
    transition: color 0.2s ease-in-out;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    margin-top: 10px;
    max-width: 240px; // Limiting paragraph width for better readability
  }
`;

// Footer component with updated content and styles
const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  // Options specific to the footer
  const contactOptions = [
    { label: 'Partner with us', value: 'partner' },
    { label: 'Ask a question', value: 'question' },
    { label: 'Submit feedback', value: 'feedback' },
  ];

  // Function to open the modal
  const handleOpenModal = () => setShowModal(true);
  // Function to close the modal
  const handleCloseModal = () => setShowModal(false);
  return (
    <FooterContainer className='sg-block page-footer'>
      <DecorativeLine />
      <FooterContent className='footer-container'>
        <FooterNav className='footer-nav'>

          <p>Explore our journey and join us as we build a brighter future together.</p>
        </FooterNav>
        <FooterNav className='footer-nav'>
          <h4>Legal</h4>
          <ul>
            <li><a href='/legal/privacy-policy'>Privacy Policy</a></li>
            <li><a href='/legal/terms-of-service'>Terms of Service</a></li>
            <li><a href='/legal/website-terms-of-use'>Website Terms of Use</a></li>
            <li><a href='/legal/dpa'>DPA</a></li>
          </ul>
          <p>Ensuring your privacy is our top priority.</p>
        </FooterNav>
        <FooterNav className='footer-nav'>
          <button onClick={handleOpenModal}>Contact Us</button>

          <ContactUsModal
            show={showModal}
            handleClose={handleCloseModal}
            options={contactOptions}
            defaultReason='feedback' // Default reason; adjust as needed
              userLoggedIn={false}
          />

        </FooterNav>
        {/* Additional FooterNav sections with more content can be added here */}
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
